var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.988,
    height: 91.002,
    viewBox: "0 0 70.988 91.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_32401",
    x: 0,
    y: 0,
    width: 70.988,
    height: 91.002,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_32401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32401-2",
    "data-name": "Path 32401",
    d: "M-19.874-57.433q.311-7.051,7.57-7.051h30.59q6.118,0,6.118,5.288a10.692,10.692,0,0,1-1.555,5.6H-8.986l-.622,16.9q2.385-.311,5.34-.518t5.34-.207q12.443,0,19.443,5.911t7,16.28a22.777,22.777,0,0,1-3.474,12.7,22.275,22.275,0,0,1-9.8,8.192A35.8,35.8,0,0,1-.587,8.518a56.22,56.22,0,0,1-9.436-.83,61.99,61.99,0,0,1-8.97-2.178,28.179,28.179,0,0,1-6.481-2.9l4.666-9.229A39.833,39.833,0,0,0-11.89-3.3,40.908,40.908,0,0,0-1.935-2.059q7.985,0,12.5-3.215A10.643,10.643,0,0,0,15.071-14.5a10.779,10.779,0,0,0-4.822-9.436Q5.427-27.257-3.8-27.257a72.8,72.8,0,0,0-9.073.622,48.558,48.558,0,0,0-8.244,1.659Z",
    transform: "translate(34.47 70.48)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIcon5);
export default __webpack_public_path__ + "static/media/number-icon5.3a8124f4c14ba443828ae3ef98c73838.svg";
export { ForwardRef as ReactComponent };